module.exports = __webpack_public_path__ + "img/welcome-48d09ac4eb3f0d18b6764e32d4ae7a9b.svg";